
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import sift from "sift";
import { WaContact } from "../models/waContact";
import { waContactsCacheSelectors } from "./DBServiceThunks";
import { CommonRootState } from "@common/types/common-root-state-type";



export interface WhatsAppViewState {

  contactFilterName: string;

}

const initialState: WhatsAppViewState = {
  contactFilterName: "",
};

const WhatsAppViewSlice = createSlice({
  name: "WhatsAppView",
  initialState,
  reducers: {
    setContactFilterName(state, action: PayloadAction<string>) {
      state.contactFilterName = action.payload;
    },

  },
});

export const getWhatsappContactsFilterd = createSelector(
  [
    (state: CommonRootState) => state,
    (state: CommonRootState) => state.WhatsAppViewReducer.contactFilterName,
  ],
  (state: CommonRootState, contactFilterName: string): WaContact[] => {

    let contactsFilter: any = {}

    if (contactFilterName) {
      const searchRegex = new RegExp(contactFilterName, "i");
      contactsFilter.$or = [
        { displayName: searchRegex },
        { name: searchRegex },
        { pushname: searchRegex },
        { shortName: searchRegex },
        { number: searchRegex },
        { "id.user": searchRegex }
      ];
    }

    const whatsappContactsFilterd = waContactsCacheSelectors.selectAll(state).filter(sift(contactsFilter))

    return whatsappContactsFilterd
  }
);

export const {
  setContactFilterName,
} = WhatsAppViewSlice.actions;
export const WhatsAppViewActions = WhatsAppViewSlice.actions;

export default WhatsAppViewSlice.reducer;
